import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DashboardLayout from "../layout/index";
import { APP_ROUTES } from "../../constants/approutes";
import { toast } from "react-toastify";
import { DatePicker, TimePicker } from "antd";
import FullScreenLoader from "../FullScreenLoader";
import dayjs from "dayjs";

function DoctorEdit() {
  const navigate = useNavigate();
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL;
  const doctorDatanew = location.state.doctorData;
  console.log(doctorDatanew,"doctorDatanew");
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({}); // Track individual field errors
  const [isWeeksOpen, setIsWeeksOpen] = useState(false);
  const [isDaysOpen, setIsDaysOpen] = useState(false);
  
  // State for existing photos
  const [existingPhotos, setExistingPhotos] = useState({
    panPhoto: null,
    adharPhoto: null,
    signaturePhoto: null,
    stampPhoto: null,
    profilePhoto: null,
  });

  // Track deletions to inform backend via query params
  const [removedPhotos, setRemovedPhotos] = useState({
    panPhoto: false,
    adharPhoto: false,
    signaturePhoto: false,
    stampPhoto: false,
    profilePhoto: false,
  });

  // State for photo modal
  const [photoModal, setPhotoModal] = useState({
    isOpen: false,
    type: null,
    currentPhoto: null,
    photoUrl: null,
  });

  const [formData, setFormData] = useState({
    doctorName: "",
    licenseNumber: "",
    qualifications: "",
    specialization: [],
    experience: "",
    phone: "",
    email1: "",
    isFamilyDoctor: "",
    fromDate: dayjs().format("YYYY-MM-DD"), // Initialize with current date
    toDate: dayjs().format("YYYY-MM-DD"),   // Initialize with current date
    timeSlots: [],
    dayOfWeek: "",
    bio: "",
    slotDuration: "",
    // Bank & account fields
    bankName: "",
    accountHolderName: "",
    ifscCode: "",
    accountNumber: "",
    bankLoc: "",
    // PAN / Aadhaar / Signature / Stamp / Profile
    panCardNumber: "",
    panPhoto: null,
    adhharCardNo: "",
    adharPhoto: null,
    signaturePhoto: null,
    stampPhoto: null,
    profilePhoto: null,
  });

  // New state for specialization search and options
  const [specializationSearch, setSpecializationSearch] = useState("");
  const [specializationOptions, setSpecializationOptions] = useState([]);
  const [loadingSpecializations, setLoadingSpecializations] = useState(false);
  const [showSpecializationDropdown, setShowSpecializationDropdown] =
    useState(false);

  // Fetch specializations from API
  const fetchSpecializations = async (searchTerm = "") => {
    try {
      setLoadingSpecializations(true);
      const url = searchTerm
        ? `${API_URL}api/v1/speciality?search=${encodeURIComponent(searchTerm)}`
        : `${API_URL}api/v1/speciality`;

      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setSpecializationOptions(data || []);
      } else {
        console.error("Failed to fetch specializations");
        setSpecializationOptions([]);
      }
    } catch (error) {
      console.error("Error fetching specializations:", error);
      setSpecializationOptions([]);
    } finally {
      setLoadingSpecializations(false);
    }
  };

  // Load specializations on component mount
  useEffect(() => {
    fetchSpecializations();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target;
      if (!target.closest(".specialization-dropdown-container")) {
        setShowSpecializationDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close weeks and days dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target;
      if (!target.closest(".weeks-dropdown-container")) {
        setIsWeeksOpen(false);
      }
      if (!target.closest(".days-dropdown-container")) {
        setIsDaysOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Debounced search for specializations
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (specializationSearch.trim()) {
        fetchSpecializations(specializationSearch);
      } else {
        fetchSpecializations();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [specializationSearch]);

  // Populate form with doctor data when editing
  useEffect(() => {
    if (location.state?.doctorData && location.state?.isEdit) {
      const doctorData = location.state.doctorData;
      console.log("Doctor data received:", doctorData);
      console.log("Doctor fees:", doctorData.doctorFee);
      console.log("Doctor bio:", doctorData.bio);
      setFormData({
        doctorName: doctorData.fullName || doctorData.doctorName || "",
        licenseNumber: doctorData.medicalLicenseNumber || doctorData.licenseNumber || "",
        qualifications: Array.isArray(doctorData.qualifications) 
          ? doctorData.qualifications.join(", ") 
          : doctorData.qualifications || "",
        specialization: doctorData.specialization || [],
        experience: doctorData.yearsOfExperience || doctorData.experience || "",
        phone: doctorData.phoneNumber || doctorData.phone || "",
        email1: doctorData.email || doctorData.email1 || "",
        isFamilyDoctor: doctorData.isFamilyDoctor != null ? String(doctorData.isFamilyDoctor) : "",
        fromDate: doctorData.fromDate || dayjs().format("YYYY-MM-DD"),
        toDate: doctorData.toDate || dayjs().format("YYYY-MM-DD"),
        timeSlots: doctorData.timeSlots || [],
        bio: doctorData.bio || "",
        slotDuration: doctorData.slotDuration || "",
        // Bank & account fields
        bankName: doctorData.bankName || "",
        accountHolderName: doctorData.accountHolderName || "",
        ifscCode: doctorData.ifscCode || "",
        accountNumber: doctorData.accountNumber || "",
        panCardNumber: doctorData.panCardNumber || "",
        bankLoc: doctorData.bankLoc || "",
        adhharCardNo: doctorData.adharCardNo || doctorData.adhharCardNo || "",
      });
      
      // Set consultation fees if available
      if (doctorData.doctorFee && doctorData.doctorFee.length > 0) {
        setConsultationFees(doctorData.doctorFee);
      } else if (doctorData.consultationFees && doctorData.consultationFees.length > 0) {
        setConsultationFees(doctorData.consultationFees);
      }
      
      // Set existing photos
      setExistingPhotos({
        panPhoto: doctorData.panPhoto || null,
        adharPhoto: doctorData.adharPhoto || null,
        signaturePhoto: doctorData.signaturePhoto || null,
        stampPhoto: doctorData.stampPhoto || null,
        profilePhoto: doctorData.profilePhoto || null,
      });

      // Set existing photos in formData as well (for validation)
      setFormData(prev => ({
        ...prev,
        panPhoto: doctorData.panPhoto ? { name: doctorData.panPhoto } : null,
        adharPhoto: doctorData.adharPhoto ? { name: doctorData.adharPhoto } : null,
        signaturePhoto: doctorData.signaturePhoto ? { name: doctorData.signaturePhoto } : null,
        stampPhoto: doctorData.stampPhoto ? { name: doctorData.stampPhoto } : null,
        profilePhoto: doctorData.profilePhoto ? { name: doctorData.profilePhoto } : null,
      }));
    }
  }, [location.state]);

  // Handle specialization selection
  const handleSpecializationSelect = (specialization) => {
    if (!formData.specialization.includes(specialization.speciality)) {
      setFormData((prev) => ({
        ...prev,
        specialization: [...prev.specialization, specialization.speciality],
      }));
      // Clear error when field is filled
      setFieldErrors(prev => ({ ...prev, specialization: null }));
    }
    setSpecializationSearch("");
    setShowSpecializationDropdown(false);
  };

  // Handle specialization removal
  const handleSpecializationRemove = (specializationToRemove) => {
    const updatedSpecializations = formData.specialization.filter(
      (spec) => spec !== specializationToRemove
    );
    setFormData((prev) => ({
      ...prev,
      specialization: updatedSpecializations,
    }));
    // Add error if no specializations left
    if (updatedSpecializations.length === 0) {
      setFieldErrors(prev => ({ ...prev, specialization: "At least one specialization is required" }));
    }
  };

  // Function to fetch photo URL and open modal
  const handleViewPhoto = async (photoType) => {
    const fileName = existingPhotos[photoType];
    if (!fileName) return;

    try {
      const token = localStorage.getItem("auth_token");
      const response = await fetch(
        `${API_URL}patient-medical-history/file-url?fileName=${fileName}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.ok) {
        const data = await response.json();
       
        setPhotoModal({
          isOpen: true,
          type: photoType,
          currentPhoto: fileName,
          photoUrl: data.signedUrl,
        });
      } else {
        toast.error("Failed to load photo");
      }
    } catch (error) {
      console.error("Error fetching photo:", error);
      toast.error("Failed to load photo");
    }
  };

  // Function to handle photo upload in modal
  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        [photoModal.type]: file,
      }));
      
      // Update modal with new photo
      const newUrl = URL.createObjectURL(file);
      setPhotoModal(prev => ({
        ...prev,
        photoUrl: newUrl,
      }));
      
      // Clear error for this field
      setFieldErrors(prev => ({ ...prev, [photoModal.type]: null }));
      
      toast.success("Photo updated successfully!");
    }
  };

  // Function to view newly uploaded file
  const handleViewNewFile = (photoType) => {
    const file = formData[photoType];
    if (file) {
      // Check if it's a File object (new upload) or existing photo data
      if (file instanceof File) {
        // New file upload - create object URL
        const fileUrl = URL.createObjectURL(file);
        setPhotoModal({
          isOpen: true,
          type: photoType,
          currentPhoto: file.name,
          photoUrl: fileUrl,
        });
      } else if (file.name) {
        // Existing photo - use the existing handleViewPhoto function
        handleViewPhoto(photoType);
      }
    }
  };

  // Function to close modal
  const closePhotoModal = () => {
    setPhotoModal({
      isOpen: false,
      type: null,
      currentPhoto: null,
      photoUrl: null,
    });
  };

  // Function to delete a photo/document
  const handleDeletePhoto = (photoType) => {
    // Clear the form data for this photo
    setFormData(prev => ({
      ...prev,
      [photoType]: null
    }));
    
    // Clear the existing photo
    setExistingPhotos(prev => ({
      ...prev,
      [photoType]: null
    }));
    
    // Mark as removed
    setRemovedPhotos(prev => ({
      ...prev,
      [photoType]: true,
    }));
    
    // Clear any error for this field
    setFieldErrors(prev => ({ ...prev, [photoType]: null }));
    
    // toast.success(`${photoType.charAt(0).toUpperCase() + photoType.slice(1)} deleted successfully!`);
  };

  // Function to clear text fields
  const handleClearField = (fieldName) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: ""
    }));
    
    // Clear any error for this field
    setFieldErrors(prev => ({ ...prev, [fieldName]: null }));
    
    toast.success(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} cleared successfully!`);
  };

  // New state for consultation fees
  const [consultationFeeEntry, setConsultationFeeEntry] = useState({
    consultationtype: "",
    consultationFee: "",
  });
  const [consultationFees, setConsultationFees] = useState([]);

  const [currentSlot, setCurrentSlot] = useState({
    dayOfWeek: [],
    startTime: "",
    endTime: "",
    weekNumbers: [],
  });

  // Validate individual field and update errors
  const validateField = (name, value) => {
    let error = null;

    // Helper function to safely check string values
    const isStringValid = (val) => {
      return val && typeof val === 'string' && val.trim();
    };

    switch (name) {
      case 'doctorName':
        if (!isStringValid(value)) error = "Doctor name is required";
        break;
      case 'licenseNumber':
        if (!isStringValid(value)) error = "Medical license number is required";
        break;
      case 'qualifications':
        if (Array.isArray(value)) {
          if (value.length === 0) error = "Qualifications are required";
        } else {
          if (!isStringValid(value)) error = "Qualifications are required";
        }
        break;
      case 'specialization':
        if (!Array.isArray(value) || value.length === 0) error = "At least one specialization is required";
        break;
      case 'isFamilyDoctor':
        if (value !== "true" && value !== "false") error = "Please select whether this is a family doctor";
        break;
      case 'experience':
        if (typeof value === 'number') {
          if (value <= 0) error = "Experience must be greater than 0";
        } else if (!isStringValid(value)) {
          error = "Experience is required";
        }
        break;
      case 'phone':
        if (!isStringValid(value)) {
          error = "Phone number is required";
        } else if (value.trim().length !== 10) {
          error = "Phone number must be exactly 10 digits";
        }
        break;
      case 'email1':
        if (!isStringValid(value)) error = "Email is required";
        break;
      case 'fromDate':
        if (!value) error = "From date is required";
        break;
      case 'toDate':
        if (!value) error = "To date is required";
        break;
      case 'timeSlots':
        if (!Array.isArray(value) || value.length === 0) error = "At least one time slot is required";
        break;
      case 'bio':
        if (!isStringValid(value)) error = "Doctor bio is required";
        break;
      case 'slotDuration':
        // Handle both string and number types
        const slotValue = value?.toString()?.trim();
        if (!slotValue) {
          error = "Slot duration is required";
        } else if (!/^\d+$/.test(slotValue)) {
          error = "Slot duration must be a number";
        } else if (parseInt(slotValue, 10) <= 0) {
          error = "Slot duration must be greater than 0";
        }
        break;
      // case 'bankName':
      //   if (!isStringValid(value)) error = "Bank name is required";
      //   break;
      // case 'bankLoc':
      //   if (!isStringValid(value)) error = "Branch location is required";
      //   break;
      // case 'accountHolderName':
      //   if (!isStringValid(value)) error = "Account holder name is required";
      //   break;
      // case 'ifscCode':
      //   if (!isStringValid(value)) error = "IFSC code is required";
      //   break;
      // case 'accountNumber':
      //   if (!isStringValid(value)) error = "Account number is required";
      //   break;
      case 'panCardNumber':
        // PAN card number is now optional
        break;
      case 'panPhoto':
        // PAN photo is now optional
        break;
      case 'adhharCardNo':
        // Aadhaar number is now optional, but if provided, validate format
        if (isStringValid(value) && value.trim().length !== 12) {
          error = "Aadhaar number must be exactly 12 digits";
        }
        break;
      case 'adharPhoto':
        // Aadhaar photo is now optional
        break;
      case 'signaturePhoto':
        // Signature photo is now optional
        break;
      case 'stampPhoto':
        // Stamp photo is now optional
        break;
      case 'profilePhoto':
        // Profile photo is now optional
        break;
      case 'consultationFees':
        if (!Array.isArray(value) || value.length === 0) error = "At least one consultation fee is required";
        break;
    }

    setFieldErrors(prev => ({ ...prev, [name]: error }));
    return error;
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    let newValue = value;

    if (type === "file") {
      newValue = files[0] || null;
      setFormData((prev) => ({ ...prev, [name]: newValue }));
      validateField(name, newValue);
      return;
    }

    // Handle date fields - keep as string format
    if (name === "fromDate" || name === "toDate") {
      newValue = value; // Already in YYYY-MM-DD format from DatePicker
      setFormData((prev) => ({ ...prev, [name]: newValue }));
      validateField(name, newValue);
      return;
    }

    // Handle boolean-select fields
    if (name === "isFamilyDoctor") {
      setFormData((prev) => ({ ...prev, [name]: newValue }));
      validateField(name, newValue);
      return;
    }

    // Field-specific sanitization/validation
    if (name === "phone") {
      newValue = value.replace(/\D/g, "").slice(0, 10);
    } else if (name === "adhharCardNo") {
      newValue = value.replace(/\D/g, "").slice(0, 12);
    } else if (name === "accountHolderName") {
      newValue = value.replace(/[^a-zA-Z ]/g, "");
    } else if (name === "accountNumber") {
      newValue = value.replace(/\D/g, "");
    }
    else if (name === "doctorName") {
      newValue = value.replace(/[^a-zA-Z ]/g, "");
    } else if (name === "bankName") {
      newValue = value.replace(/[^a-zA-Z ]/g, "");
    } 

    setFormData((prev) => ({ ...prev, [name]: newValue }));
    validateField(name, newValue);
  };

  const isFormValid = () => {
    return (
      formData.doctorName.trim() &&
      formData.licenseNumber.trim() &&
      formData.qualifications.trim() &&
      formData.specialization.length > 0 &&
      (typeof formData.experience === 'number' ? formData.experience > 0 : formData.experience.trim()) &&
      formData.phone.trim().length === 10 &&
      formData.email1.trim() &&
      (formData.isFamilyDoctor === "true" || formData.isFamilyDoctor === "false") &&
      formData.fromDate &&
      formData.toDate &&
      formData.timeSlots.length > 0 &&
      formData.bio.trim() &&
      consultationFees.length > 0
      //–– Bank fields and document fields are now optional
    );
  };

  // Validate all fields and show errors
  const validateAllFields = () => {
    const errors = {};
    console.log("FormData:", formData);
    console.log("Existing Photos:", existingPhotos);
    console.log("Consultation Fees:", consultationFees);
    
    // Validate all required fields
    const fieldsToValidate = [
      'doctorName', 'licenseNumber', 'qualifications', 'specialization',
      'experience', 'phone', 'email1', 'isFamilyDoctor', 'fromDate', 'toDate', 'timeSlots',
      'bio', 'slotDuration'
      // Bank and document fields are now optional
    ];

    fieldsToValidate.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      const error = validateField(fieldName, fieldValue);
      if (error) {
        errors[fieldName] = error;
        console.log(`Validation error for ${fieldName}:`, error, "Value:", fieldValue);
      }
    });

    // Validate consultation fees separately
    if (consultationFees.length === 0) {
      errors.consultationFees = "At least one consultation fee is required";
      setFieldErrors(prev => ({ ...prev, consultationFees: "At least one consultation fee is required" }));
      console.log("Consultation fees validation error: No fees added");
    }

    console.log("All validation errors:", errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = async () => {
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    const doctorId = doctorDatanew?.doctorCode;
    
    if (!doctorId) {
      toast.error("Doctor ID not found. Please try again.");
      return;
    }
    
    if (!validateAllFields()) {
      // Get all field errors to show specific missing fields
      const allErrors = {};
      const fieldsToValidate = [
        'doctorName', 'licenseNumber', 'qualifications', 'specialization', 
        'experience', 'phone', 'email1', 'fromDate', 'toDate', 'timeSlots', 
        'bio', 'slotDuration'
        // Bank and document fields are now optional
      ];

      fieldsToValidate.forEach(fieldName => {
        const fieldValue = formData[fieldName];
        const error = validateField(fieldName, fieldValue);
        if (error) {
          allErrors[fieldName] = error;
        }
      });

      if (consultationFees.length === 0) {
        allErrors.consultationFees = "At least one consultation fee is required";
      }

      const missingFields = Object.keys(allErrors);
      console.log("Missing fields:", missingFields);
      toast.error(`Please fill the following required fields: ${missingFields.join(", ")}`);
      return;
    }
    
    setIsLoggingIn(true);

    const qualificationArray = Array.isArray(formData.qualifications)
      ? formData.qualifications
      : formData.qualifications
          .split(",")
          .map((q) => q.trim())
          .filter((q) => q.length > 0);

    const doctorPayload = {
      fullName: formData.doctorName,
      medicalLicenseNumber: formData.licenseNumber,
      qualifications: qualificationArray,
      specialization: formData.specialization,
      yearsOfExperience: parseInt(formData.experience, 10),
      bio: formData.bio,
      slotDuration: formData.slotDuration,
      phoneNumber: formData.phone,
      email: formData.email1,
      isFamilyDoctor: formData.isFamilyDoctor === "true",
      fromDate: formData.fromDate,
      toDate: formData.toDate,
      timeSlots: formData.timeSlots,
      doctorFee: consultationFees,
      clinicId: tenantId,
      bankName: formData.bankName,
      accountHolderName: formData.accountHolderName,
      ifscCode: formData.ifscCode,
      accountNumber: formData.accountNumber,
      panCardNumber: formData.panCardNumber,
      adharCardNo: formData.adhharCardNo,
      fcmToken: "",
      bioMetricID: "",
      bankLoc: formData.bankLoc,
      tenantId: tenantId
    };

    const payload = new FormData();
    payload.append("doctor", JSON.stringify(doctorPayload));
    
    // Handle photo files - only append if they are actual File objects (new uploads)
    if (formData.panPhoto && formData.panPhoto instanceof File) {
      payload.append("panPhoto", formData.panPhoto);
    } else if (existingPhotos.panPhoto) {
      // Send existing filename as a string field
      payload.append("existingPanPhoto", existingPhotos.panPhoto);
    }
    
    if (formData.adharPhoto && formData.adharPhoto instanceof File) {
      payload.append("adharPhoto", formData.adharPhoto);
    } else if (existingPhotos.adharPhoto) {
      payload.append("existingAdharPhoto", existingPhotos.adharPhoto);
    }
    
    if (formData.signaturePhoto && formData.signaturePhoto instanceof File) {
      payload.append("signaturePhoto", formData.signaturePhoto);
    } else if (existingPhotos.signaturePhoto) {
      payload.append("existingSignaturePhoto", existingPhotos.signaturePhoto);
    }
    
    if (formData.stampPhoto && formData.stampPhoto instanceof File) {
      payload.append("stampPhoto", formData.stampPhoto);
    } else if (existingPhotos.stampPhoto) {
      payload.append("existingStampPhoto", existingPhotos.stampPhoto);
    }
    
    if (formData.profilePhoto && formData.profilePhoto instanceof File) {
      payload.append("profilePhoto", formData.profilePhoto);
    } else if (existingPhotos.profilePhoto) {
      payload.append("existingProfilePhoto", existingPhotos.profilePhoto);
    }

    console.log("Doctor Update Payload:", payload);

    const token = localStorage.getItem("auth_token");
    try {
      // Build URL with query param if any photo was removed or replaced
      let updateUrl = `${API_URL}doctor/update/${doctorId}`;
      const params = new URLSearchParams();
      if (removedPhotos.panPhoto || (formData.panPhoto && formData.panPhoto instanceof File && existingPhotos.panPhoto)) {
        params.append("removePanPhoto", "true");
      }
      if (removedPhotos.adharPhoto || (formData.adharPhoto && formData.adharPhoto instanceof File && existingPhotos.adharPhoto)) {
        params.append("removeAdharPhoto", "true");
      }
      if (removedPhotos.signaturePhoto || (formData.signaturePhoto && formData.signaturePhoto instanceof File && existingPhotos.signaturePhoto)) {
        params.append("removeSignaturePhoto", "true");
      }
      if (removedPhotos.stampPhoto || (formData.stampPhoto && formData.stampPhoto instanceof File && existingPhotos.stampPhoto)) {
        params.append("removeStampPhoto", "true");
      }
      if (removedPhotos.profilePhoto || (formData.profilePhoto && formData.profilePhoto instanceof File && existingPhotos.profilePhoto)) {
        params.append("removeProfilePhoto", "true");
      }
      if ([...params].length > 0) {
        updateUrl += `?${params.toString()}`;
      }

      const res = await fetch(updateUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
        body: payload,
      });

      const result = await res.json();
      setIsLoggingIn(false);
     
      console.log("Update result:", result,res.status);

      if (res.status === 200) {
        handleSubmitTenant();
       
      } else if (result.error) {
        toast.error(result.error);
      } else {
        toast.error(result.message || "Update failed.");
      }
    } catch (error) {
      console.error("API error:", error);
      toast.error("Something went wrong while updating doctor.");
      setIsLoggingIn(false);
    }
  };

  const handleSubmitTenant = async () => {
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    const doctorId = doctorDatanew?.doctorCode;
    
    if (!doctorId) {
      toast.error("Doctor ID not found. Please try again.");
      return;
    }
    
    if (!validateAllFields()) {
      // Get all field errors to show specific missing fields
      const allErrors = {};
      const fieldsToValidate = [
        'doctorName', 'licenseNumber', 'qualifications', 'specialization', 
        'experience', 'phone', 'email1', 'fromDate', 'toDate', 'timeSlots', 
        'bio', 'slotDuration'
        // Bank and document fields are now optional
      ];

      fieldsToValidate.forEach(fieldName => {
        const fieldValue = formData[fieldName];
        const error = validateField(fieldName, fieldValue);
        if (error) {
          allErrors[fieldName] = error;
        }
      });

      if (consultationFees.length === 0) {
        allErrors.consultationFees = "At least one consultation fee is required";
      }

      const missingFields = Object.keys(allErrors);
      console.log("Missing fields:", missingFields);
      toast.error(`Please fill the following required fields: ${missingFields.join(", ")}`);
      return;
    }
    
    setIsLoggingIn(true);

    const qualificationArray = Array.isArray(formData.qualifications)
      ? formData.qualifications
      : formData.qualifications
          .split(",")
          .map((q) => q.trim())
          .filter((q) => q.length > 0);

    const doctorPayload = {
      fullName: formData.doctorName,
      medicalLicenseNumber: formData.licenseNumber,
      qualifications: qualificationArray,
      specialization: formData.specialization,
      yearsOfExperience: parseInt(formData.experience, 10),
      bio: formData.bio,
      slotDuration: formData.slotDuration,
      phoneNumber: formData.phone,
      email: formData.email1,
      isFamilyDoctor: formData.isFamilyDoctor === "true",
      fromDate: formData.fromDate,
      toDate: formData.toDate,
      timeSlots: formData.timeSlots,
      doctorFee: consultationFees,
      clinicId: tenantId,
      bankName: formData.bankName,
      accountHolderName: formData.accountHolderName,
      ifscCode: formData.ifscCode,
      accountNumber: formData.accountNumber,
      panCardNumber: formData.panCardNumber,
      adharCardNo: formData.adhharCardNo,
      fcmToken: "",
      bioMetricID: "",
      bankLoc: formData.bankLoc,
      tenantId: tenantId
    };

    const payload = new FormData();
    payload.append("doctor", JSON.stringify(doctorPayload));
    
    // Handle photo files - only append if they are actual File objects (new uploads)
    if (formData.panPhoto && formData.panPhoto instanceof File) {
      payload.append("panPhoto", formData.panPhoto);
    } else if (existingPhotos.panPhoto) {
      // Send existing filename as a string field
      payload.append("existingPanPhoto", existingPhotos.panPhoto);
    }
    
    if (formData.adharPhoto && formData.adharPhoto instanceof File) {
      payload.append("adharPhoto", formData.adharPhoto);
    } else if (existingPhotos.adharPhoto) {
      payload.append("existingAdharPhoto", existingPhotos.adharPhoto);
    }
    
    if (formData.signaturePhoto && formData.signaturePhoto instanceof File) {
      payload.append("signaturePhoto", formData.signaturePhoto);
    } else if (existingPhotos.signaturePhoto) {
      payload.append("existingSignaturePhoto", existingPhotos.signaturePhoto);
    }
    
    if (formData.stampPhoto && formData.stampPhoto instanceof File) {
      payload.append("stampPhoto", formData.stampPhoto);
    } else if (existingPhotos.stampPhoto) {
      payload.append("existingStampPhoto", existingPhotos.stampPhoto);
    }
    
    if (formData.profilePhoto && formData.profilePhoto instanceof File) {
      payload.append("profilePhoto", formData.profilePhoto);
    } else if (existingPhotos.profilePhoto) {
      payload.append("existingProfilePhoto", existingPhotos.profilePhoto);
    }

    console.log("Doctor Update Payload:", payload);

    const token = localStorage.getItem("auth_token");
    try {
      // Build URL with query param if any photo was removed or replaced
      let updateUrl = `${API_URL}doctor/update/${doctorId}`;
      const params = new URLSearchParams();
      if (removedPhotos.panPhoto || (formData.panPhoto && formData.panPhoto instanceof File && existingPhotos.panPhoto)) {
        params.append("removePanPhoto", "true");
      }
      if (removedPhotos.adharPhoto || (formData.adharPhoto && formData.adharPhoto instanceof File && existingPhotos.adharPhoto)) {
        params.append("removeAdharPhoto", "true");
      }
      if (removedPhotos.signaturePhoto || (formData.signaturePhoto && formData.signaturePhoto instanceof File && existingPhotos.signaturePhoto)) {
        params.append("removeSignaturePhoto", "true");
      }
      if (removedPhotos.stampPhoto || (formData.stampPhoto && formData.stampPhoto instanceof File && existingPhotos.stampPhoto)) {
        params.append("removeStampPhoto", "true");
      }
      if (removedPhotos.profilePhoto || (formData.profilePhoto && formData.profilePhoto instanceof File && existingPhotos.profilePhoto)) {
        params.append("removeProfilePhoto", "true");
      }
      if ([...params].length > 0) {
        updateUrl += `?${params.toString()}`;
      }

      const res = await fetch(updateUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        
        },
        body: payload,
      });

      const result = await res.json();
      setIsLoggingIn(false);
     
      console.log("Update result:", result,res.status);

      if (res.status === 200) {
       toast.success("Doctor updated successfully!");
       navigate(APP_ROUTES.DOCTORLIST);
       return;
      } else if (result.error) {
        toast.error(result.error);
      } else {
        toast.error(result.message || "Update failed.");
      }
    } catch (error) {
      console.error("API error:", error);
      toast.error("Something went wrong while updating doctor.");
      setIsLoggingIn(false);
    }
  };

  return (
    <>
      {isLoggingIn && <FullScreenLoader message="" />}

      <DashboardLayout>
        <div className="min-h-screen bg-white p-4 md:pt-10">
          <h2 className="text-lg font-semibold text-[#004276] md:text-xl">
            Doctor Onboard
          </h2>

          <div className="mt-8 space-y-8">
            {/* ────────────────────────────────────────────────────────────────────── */}
            {/* BASIC DOCTOR INFO */}
            {/* ────────────────────────────────────────────────────────────────────── */}
            <div className="rounded-lg border border-gray-200 p-6 shadow-sm">
              <h3 className="mb-4 text-lg font-semibold text-[#004276]">
                Basic Information
              </h3>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                <InputField
                  label="Doctor Name"
                  name="doctorName"
                  value={formData.doctorName}
                  onChange={handleChange}
                  error={fieldErrors.doctorName}
                  readOnly
                />
                <InputField
                  label="Medical License Number"
                  name="licenseNumber"
                  value={formData.licenseNumber}
                  onChange={handleChange}
                  error={fieldErrors.licenseNumber}
                  readOnly
                />
                <InputField
                  label="Qualifications"
                  name="qualifications"
                  value={formData.qualifications}
                  onChange={handleChange}
                  error={fieldErrors.qualifications}
                />
                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Specialization <span className="text-red-500">*</span>
                  </label>
                  <div className="relative specialization-dropdown-container">
                    <input
                      type="text"
                      placeholder="Search or select specializations..."
                      value={specializationSearch}
                      onChange={(e) => setSpecializationSearch(e.target.value)}
                      onFocus={() => setShowSpecializationDropdown(true)}
                      className={`w-full rounded-lg border px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
                        fieldErrors.specialization ? 'border-red-500' : 'border-gray-200'
                      }`}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setShowSpecializationDropdown(
                          !showSpecializationDropdown
                        )
                      }
                      className="absolute right-8 top-1/2 transform -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      <svg
                        className={`w-4 h-4 transition-transform ${
                          showSpecializationDropdown ? "rotate-180" : ""
                        }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>
                    {loadingSpecializations && (
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#3cba84]"></div>
                      </div>
                    )}

                    {/* Dropdown for specialization options */}
                    {showSpecializationDropdown &&
                      specializationOptions.length > 0 && (
                        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                          {specializationOptions
                            .filter((option) => option.status === 1) // Only show active specializations
                            .filter(
                              (option) =>
                                !specializationSearch ||
                                option.speciality
                                  .toLowerCase()
                                  .includes(specializationSearch.toLowerCase())
                            ) // Filter by search term if provided
                            .map((option, index) => (
                              <button
                                key={option.id || index}
                                type="button"
                                onClick={() =>
                                  handleSpecializationSelect(option)
                                }
                                className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm text-gray-700"
                              >
                                {option.speciality}
                              </button>
                            ))}
                        </div>
                      )}
                  </div>

                  {/* Selected specializations */}
                  {formData.specialization.length > 0 && (
                    <div className="mt-2 flex flex-wrap gap-2">
                      {formData.specialization.map((spec, index) => (
                        <span
                          key={index}
                          className="inline-flex items-center gap-1 bg-[#3cba84] text-white px-3 py-1 rounded-full text-xs"
                        >
                          {spec}
                          <button
                            type="button"
                            onClick={() => handleSpecializationRemove(spec)}
                            className="ml-1 hover:bg-[#2da06f] rounded-full w-4 h-4 flex items-center justify-center text-xs"
                          >
                            ×
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                  
                  {/* Error message for specialization */}
                  {fieldErrors.specialization && (
                    <p className="text-red-500 text-xs mt-1">{fieldErrors.specialization}</p>
                  )}
                </div>
                <InputField
                  label="Experience (Years)"
                  name="experience"
                  value={formData.experience}
                  onChange={handleChange}
                  error={fieldErrors.experience}
                />
                <InputField
                  label="Phone Number"
                  name="phone"
                  type="tel"
                  maxLength={10}
                  value={formData.phone}
                  onChange={handleChange}
                  error={fieldErrors.phone}
                  readOnly
                />
                <InputField
                  label="Email Id"
                  name="email1"
                  type="email"
                  value={formData.email1}
                  onChange={handleChange}
                  error={fieldErrors.email1}
                  readOnly
                />
                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Family Doctor <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="isFamilyDoctor"
                    value={formData.isFamilyDoctor}
                    onChange={handleChange}
                    className={`w-full rounded-lg border px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${fieldErrors.isFamilyDoctor ? 'border-red-500' : 'border-gray-200'
                      }`}
                  >
                    <option value="">Select</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                  {fieldErrors.isFamilyDoctor && (
                    <p className="text-red-500 text-xs mt-1">{fieldErrors.isFamilyDoctor}</p>
                  )}
                </div>
              </div>
            </div>

            {/* ────────────────────────────────────────────────────────────────────── */}
            {/* REQUIRED DOCUMENTS */}
            {/* ────────────────────────────────────────────────────────────────────── */}
            <div className="rounded-lg border border-gray-200 p-6 shadow-sm">
              <h3 className="mb-4 text-lg font-semibold text-[#004276]">
                Required Documents
              </h3>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    PAN Card Number
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="panCardNumber"
                      value={formData.panCardNumber}
                      onChange={handleChange}
                      placeholder="Enter here"
                      className={`w-full rounded-lg border px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
                        fieldErrors.panCardNumber ? 'border-red-500' : 'border-gray-200'
                      }`}
                    />
                  </div>
                  {fieldErrors.panCardNumber && (
                    <p className="text-red-500 text-xs mt-1">{fieldErrors.panCardNumber}</p>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    PAN Photo (Image/PDF)
                  </label>
                  
                  {/* Show existing photo button if available */}
                 
                  
                  <input
                    type="file"
                    name="panPhoto"
                    accept="image/*,application/pdf"
                    onChange={handleChange}
                    className={`w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
                      fieldErrors.panPhoto ? 'border-red-500' : 'border-gray-200'
                    }`}
                  />
                   {existingPhotos.panPhoto && !formData.panPhoto && (
                     <div className="mt-2 flex items-center gap-2">
                     <p className="text-xs text-gray-600">Selected: {existingPhotos.panPhoto}</p>
                     <button
                       type="button"
                       onClick={() => handleViewPhoto('panPhoto')}
                       className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition-colors"
                     >
                       View Image
                     </button>
                     <button
                       type="button"
                       onClick={() => handleDeletePhoto('panPhoto')}
                       className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
                       title="Delete PAN Photo"
                     >
                       <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                       </svg>
                     </button>
                   </div>

                    // <div className="mb-2">
                    //   <button
                    //     type="button"
                    //     onClick={() => handleViewPhoto('panPhoto')}
                    //     className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm transition-colors"
                    //   >
                    //     View Current PAN Photo
                    //   </button>
                    // </div>
                  )}
                  {formData.panPhoto && (
                    <div className="mt-2 flex items-center gap-2">
                      <p className="text-xs text-gray-600">Selected: {formData.panPhoto.name}</p>
                      <button
                        type="button"
                        onClick={() => handleViewNewFile('panPhoto')}
                        className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition-colors"
                      >
                        View {formData.panPhoto.type && formData.panPhoto.type.startsWith('image/') ? 'Image' : 'PDF'}
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDeletePhoto('panPhoto')}
                        className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
                        title="Delete PAN Photo"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  )}
                  
                  {fieldErrors.panPhoto && (
                    <p className="text-red-500 text-xs mt-1">{fieldErrors.panPhoto}</p>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Aadhaar Number
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="adhharCardNo"
                      value={formData.adhharCardNo}
                      onChange={handleChange}
                      placeholder="Enter here"
                      className={`w-full rounded-lg border px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
                        fieldErrors.adhharCardNo ? 'border-red-500' : 'border-gray-200'
                      }`}
                    />
                  </div>
                  {fieldErrors.adhharCardNo && (
                    <p className="text-red-500 text-xs mt-1">{fieldErrors.adhharCardNo}</p>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Aadhaar Photo (Image/PDF)
                  </label>
                  
                 
                  
                  <input
                    type="file"
                    name="adharPhoto"
                    accept="image/*,application/pdf"
                    onChange={handleChange}
                    className={`w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
                      fieldErrors.adharPhoto ? 'border-red-500' : 'border-gray-200'
                    }`}
                  />
                   {existingPhotos.adharPhoto && !formData.adharPhoto && (
                    <div className="mt-2 flex items-center gap-2">
                    <p className="text-xs text-gray-600">Selected: {existingPhotos.adharPhoto}</p>
                    <button
                      type="button"
                      onClick={() => handleViewPhoto('adharPhoto')}
                      className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition-colors"
                    >
                      View Image
                    </button>
                    <button
                      type="button"
                      onClick={() => handleDeletePhoto('adharPhoto')}
                      className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
                      title="Delete Aadhaar Photo"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                  )}
                  {formData.adharPhoto && (
                    <div className="mt-2 flex items-center gap-2">
                      <p className="text-xs text-gray-600">Selected: {formData.adharPhoto.name}</p>
                      <button
                        type="button"
                        onClick={() => handleViewNewFile('adharPhoto')}
                        className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition-colors"
                      >
                        View {formData.adharPhoto.type && formData.adharPhoto.type.startsWith('image/') ? 'Image' : 'PDF'}
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDeletePhoto('adharPhoto')}
                        className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
                        title="Delete Aadhaar Photo"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  )}
                  
                  {fieldErrors.adharPhoto && (
                    <p className="text-red-500 text-xs mt-1">{fieldErrors.adharPhoto}</p>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Signature Photo
                  </label>
                  
                 
                  
                  <input
                    type="file"
                    name="signaturePhoto"
                    accept="image/*,application/pdf"
                    onChange={handleChange}
                    className={`w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
                      fieldErrors.signaturePhoto ? 'border-red-500' : 'border-gray-200'
                    }`}
                  />

{existingPhotos.signaturePhoto && !formData.signaturePhoto && (
    <div className="mt-2 flex items-center gap-2">
    <p className="text-xs text-gray-600">Selected: {existingPhotos.signaturePhoto}</p>
    <button
      type="button"
      onClick={() => handleViewPhoto('signaturePhoto')}
      className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition-colors"
    >
      View Image
    </button>
    <button
      type="button"
      onClick={() => handleDeletePhoto('signaturePhoto')}
      className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
      title="Delete Signature Photo"
    >
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
    </button>
  </div>
                  )}

                  
                  {formData.signaturePhoto && (
                    <div className="mt-2 flex items-center gap-2">
                      <p className="text-xs text-gray-600">Selected: {formData.signaturePhoto.name}</p>
                      <button
                        type="button"
                        onClick={() => handleViewNewFile('signaturePhoto')}
                        className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition-colors"
                      >
                        View {formData.signaturePhoto.type && formData.signaturePhoto.type.startsWith('image/') ? 'Image' : 'PDF'}
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDeletePhoto('signaturePhoto')}
                        className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
                        title="Delete Signature Photo"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  )}
                  
                  {fieldErrors.signaturePhoto && (
                    <p className="text-red-500 text-xs mt-1">{fieldErrors.signaturePhoto}</p>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Stamp Photo
                  </label>
                  
                 
                  
                  <input
                    type="file"
                    name="stampPhoto"
                    accept="image/*,application/pdf"
                    onChange={handleChange}
                    className={`w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
                      fieldErrors.stampPhoto ? 'border-red-500' : 'border-gray-200'
                    }`}
                  />
                   {existingPhotos.stampPhoto && !formData.stampPhoto && (
                   
                     <div className="mt-2 flex items-center gap-2">
                     <p className="text-xs text-gray-600">Selected: {existingPhotos.stampPhoto}</p>
                     <button
                       type="button"
                       onClick={() => handleViewPhoto('stampPhoto')}
                       className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition-colors"
                     >
                       View Image
                     </button>
                     <button
                       type="button"
                       onClick={() => handleDeletePhoto('stampPhoto')}
                       className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
                       title="Delete Stamp Photo"
                     >
                       <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                       </svg>
                     </button>
                   </div>
                  )}
                  {formData.stampPhoto && (
                    <div className="mt-2 flex items-center gap-2">
                      <p className="text-xs text-gray-600">Selected: {formData.stampPhoto.name}</p>
                      <button
                        type="button"
                        onClick={() => handleViewNewFile('stampPhoto')}
                        className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition-colors"
                      >
                        View {formData.stampPhoto.type && formData.stampPhoto.type.startsWith('image/') ? 'Image' : 'PDF'}
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDeletePhoto('stampPhoto')}
                        className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
                        title="Delete Stamp Photo"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  )}
                  
                  {fieldErrors.stampPhoto && (
                    <p className="text-red-500 text-xs mt-1">{fieldErrors.stampPhoto}</p>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Profile Photo
                  </label>
                  
                 
                  
                  <input
                    type="file"
                    name="profilePhoto"
                    accept="image/*,application/pdf"
                    onChange={handleChange}
                    className={`w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
                      fieldErrors.profilePhoto ? 'border-red-500' : 'border-gray-200'
                    }`}
                  />
                   {existingPhotos.profilePhoto && !formData.profilePhoto && (
                    // <div className="mb-2">
                    //   <button
                    //     type="button"
                    //     onClick={() => handleViewPhoto('profilePhoto')}
                    //     className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm transition-colors"
                    //   >
                    //     View Current Profile Photo
                    //   </button>
                    // </div>
                     <div className="mt-2 flex items-center gap-2">
                     <p className="text-xs text-gray-600">Selected: {existingPhotos.profilePhoto}</p>
                     <button
                       type="button"
                       onClick={() => handleViewPhoto('profilePhoto')}
                       className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition-colors"
                     >
                       View Image
                     </button>
                     <button
                       type="button"
                       onClick={() => handleDeletePhoto('profilePhoto')}
                       className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
                       title="Delete Profile Photo"
                     >
                       <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                       </svg>
                     </button>
                   </div>
                  )}
                  {formData.profilePhoto && (
                    <div className="mt-2 flex items-center gap-2">
                      <p className="text-xs text-gray-600">Selected: {formData.profilePhoto.name}</p>
                      <button
                        type="button"
                        onClick={() => handleViewNewFile('profilePhoto')}
                        className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition-colors"
                      >
                        View {formData.profilePhoto.type && formData.profilePhoto.type.startsWith('image/') ? 'Image' : 'PDF'}
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDeletePhoto('profilePhoto')}
                        className="bg-red-500 hover:bg-red-600 text-white p-1 rounded transition-colors"
                        title="Delete Profile Photo"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  )}
                  
                  {fieldErrors.profilePhoto && (
                    <p className="text-red-500 text-xs mt-1">{fieldErrors.profilePhoto}</p>
                  )}
                </div>
              </div>
            </div>

            {/* ────────────────────────────────────────────────────────────────────── */}
            {/* BANK DETAILS */}
            {/* ────────────────────────────────────────────────────────────────────── */}
            <div className="rounded-lg border border-gray-200 p-6 shadow-sm">
              <h3 className="mb-4 text-lg font-semibold text-[#004276]">
                Bank Details
              </h3>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                <InputField
                  label="Bank Name"
                  name="bankName"
                  value={formData.bankName}
                  onChange={handleChange}
                  error={fieldErrors.bankName}
                  showRequired={false}
                />
                <InputField
                  label="Branch Location"
                  name="bankLoc"
                  value={formData.bankLoc}
                  onChange={handleChange}
                  error={fieldErrors.bankLoc}
                  showRequired={false}
                />
                <InputField
                  label="Account Holder Name"
                  name="accountHolderName"
                  value={formData.accountHolderName}
                  onChange={handleChange}
                  error={fieldErrors.accountHolderName}
                  showRequired={false}
                />
                <InputField
                  label="IFSC Code"
                  name="ifscCode"
                  value={formData.ifscCode}
                  onChange={handleChange}
                  error={fieldErrors.ifscCode}
                  showRequired={false}
                />
                <InputField
                  label="Account Number"
                  name="accountNumber"
                  value={formData.accountNumber}
                  onChange={handleChange}
                  error={fieldErrors.accountNumber}
                  showRequired={false}
                />
              </div>
            </div>

            {/* ────────────────────────────────────────────────────────────────────── */}
            {/* CONSULTATION FEES */}
            {/* ────────────────────────────────────────────────────────────────────── */}
            <div className="rounded-lg border border-gray-200 p-6 shadow-sm">
              <h3 className="mb-4 text-lg font-semibold text-[#004276]">
                Consultation Fees <span className="text-red-500">*</span>
              </h3>
              <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Consultation Type <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="consultationtype"
                    value={consultationFeeEntry.consultationtype}
                    onChange={(e) =>
                      setConsultationFeeEntry((prev) => ({
                        ...prev,
                        consultationtype: e.target.value,
                      }))
                    }
                    className="w-full rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition"
                  >
                    <option value="">Select</option>
                    <option value="V">Video</option>
                    <option value="I">In-Person</option>
                  </select>
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Fee (₹) <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    min="0"
                    name="consultationFee"
                    value={consultationFeeEntry.consultationFee}
                    onChange={(e) =>
                      setConsultationFeeEntry((prev) => ({
                        ...prev,
                        consultationFee: e.target.value,
                      }))
                    }
                    className="w-full rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition"
                    placeholder="Enter fee"
                  />
                </div>
                <div className="flex flex-col justify-end">
                  <button
                    type="button"
                    className="w-full bg-[#004276] hover:bg-[#003a5c] text-white py-2 px-6 rounded-lg transition"
                    onClick={() => {
                      if (
                        consultationFeeEntry.consultationtype &&
                        consultationFeeEntry.consultationFee &&
                        !consultationFees.some(
                          (f) =>
                            f.consultationtype ===
                            consultationFeeEntry.consultationtype
                        )
                      ) {
                        setConsultationFees((prev) => [
                          ...prev,
                          {
                            consultationtype:
                              consultationFeeEntry.consultationtype,
                            consultationFee: Number(
                              consultationFeeEntry.consultationFee
                            ),
                          },
                        ]);
                        setConsultationFeeEntry({
                          consultationtype: "",
                          consultationFee: "",
                        });
                        // Clear error when fee is added
                        setFieldErrors(prev => ({ ...prev, consultationFees: null }));
                      } else if (
                        consultationFees.some(
                          (f) =>
                            f.consultationtype ===
                            consultationFeeEntry.consultationtype
                        )
                      ) {
                        toast.error("Fee for this type already added.");
                      } else {
                        toast.error("Please select type and enter fee.");
                      }
                    }}
                  >
                    Add
                  </button>
                </div>
              </div>

              {/* List of added fees */}
              {consultationFees.length > 0 && (
                <div className="mt-4 space-y-2">
                  {consultationFees.map((fee, idx) => (
                    <div
                      key={idx}
                      className="flex items-center justify-between bg-gray-100 px-4 py-2 rounded-lg"
                    >
                      <span className="text-sm text-gray-700">
                        {fee.consultationtype === "V" ? "Video" : "In-Person"}{" "}
                        Consultation: ₹{fee.consultationFee}
                      </span>
                      <button
                        type="button"
                        className="text-red-500 hover:text-red-700 font-bold ml-4 transition"
                        onClick={() => {
                          const updatedFees = consultationFees.filter((_, i) => i !== idx);
                          setConsultationFees(updatedFees);
                          // Add error if no fees left
                          if (updatedFees.length === 0) {
                            setFieldErrors(prev => ({ ...prev, consultationFees: "At least one consultation fee is required" }));
                          }
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}
              
              {/* Error message for consultation fees */}
              {fieldErrors.consultationFees && (
                <p className="text-red-500 text-xs mt-2">{fieldErrors.consultationFees}</p>
              )}
            </div>

            {/* ────────────────────────────────────────────────────────────────────── */}
            {/* DOCTOR AVAILABILITY */}
            {/* ────────────────────────────────────────────────────────────────────── */}
            <div className="rounded-lg border border-gray-200 p-6 shadow-sm">
              <h3 className="mb-4 text-lg font-semibold text-[#004276]">
                Doctor Availability <span className="text-red-500">*</span>
              </h3>

              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-6">
                <div className="flex flex-col">
                  <DatePickerField
                    label="From Date"
                    name="fromDate"
                    value={formData.fromDate}
                    onChange={handleChange}
                    error={fieldErrors.fromDate}
                  />
                </div>
                <div className="flex flex-col">
                  <DatePickerField
                    label="To Date"
                    name="toDate"
                    value={formData.toDate}
                    onChange={handleChange}
                    error={fieldErrors.toDate}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Weeks
                  </label>
                  <div className="relative weeks-dropdown-container">
                    <div
                      onClick={() => setIsWeeksOpen(!isWeeksOpen)}
                      className="w-full rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition cursor-pointer bg-white"
                    >
                      {currentSlot.weekNumbers.length > 0 
                        ? `Selected: ${currentSlot.weekNumbers.join(", ")}`
                        : "Select Week"
                      }
                    </div>
                    
                    {isWeeksOpen && (
                      <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                        {[1, 2, 3, 4, 5].map((week) => (
                          <div
                            key={week}
                            onClick={() => {
                              const alreadySelected = currentSlot.weekNumbers.includes(week);
                              setCurrentSlot((prev) => ({
                                ...prev,
                                weekNumbers: alreadySelected
                                  ? prev.weekNumbers.filter((w) => w !== week)
                                  : [...prev.weekNumbers, week],
                              }));
                            }}
                            className={`flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-50 ${
                              currentSlot.weekNumbers.includes(week)
                                ? "bg-blue-50 border-r-4 border-blue-500"
                                : ""
                            }`}
                          >
                            <div className="flex items-center">
                              <div
                                className={`w-4 h-4 border-2 mr-3 flex items-center justify-center ${
                                  currentSlot.weekNumbers.includes(week)
                                    ? "bg-blue-500 border-blue-500"
                                    : "border-gray-300"
                                }`}
                              >
                                {currentSlot.weekNumbers.includes(week) && (
                                  <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                  </svg>
                                )}
                              </div>
                              <span className={currentSlot.weekNumbers.includes(week) ? "text-blue-700 font-medium" : "text-gray-700"}>
                                Week {week}
                              </span>
                            </div>
                            {currentSlot.weekNumbers.includes(week) && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setCurrentSlot((prev) => ({
                                    ...prev,
                                    weekNumbers: prev.weekNumbers.filter((w) => w !== week),
                                  }));
                                }}
                                className="w-5 h-5 bg-red-100 rounded-full hover:bg-red-200 text-red-600 flex items-center justify-center"
                              >
                                ×
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* <div className="flex flex-col">
                  <SelectField
                    label="Day"
                    name="dayOfWeek"
                    value={currentSlot.dayOfWeek}
                    onChange={(e) =>
                      setCurrentSlot((prev) => ({
                        ...prev,
                        dayOfWeek: e.target.value,
                      }))
                    }
                    options={[
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                      "Sunday",
                    ]}
                  />
                </div> */}
                <div className="flex flex-col">                   
                  <label className="text-sm text-[#004276] mb-1 font-medium">                     
                    Days                   
                  </label>
                  <div className="relative days-dropdown-container">
                    <div
                      onClick={() => setIsDaysOpen(!isDaysOpen)}
                      className="w-full rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition cursor-pointer bg-white"
                    >
                      {currentSlot.dayOfWeek.length > 0 
                        ? `Selected: ${currentSlot.dayOfWeek.join(", ")}`
                        : "Select Day"
                      }
                    </div>
                    
                    {isDaysOpen && (
                      <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                        {[
                          "Monday",
                          "Tuesday", 
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday", 
                          "Sunday"
                        ].map((day) => (
                          <div
                            key={day}
                            onClick={() => {
                              const alreadySelected = currentSlot.dayOfWeek.includes(day);
                              setCurrentSlot((prev) => ({
                                ...prev,
                                dayOfWeek: alreadySelected
                                  ? prev.dayOfWeek.filter((d) => d !== day)
                                  : [...prev.dayOfWeek, day],
                              }));
                            }}
                            className={`flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-50 ${
                              currentSlot.dayOfWeek.includes(day)
                                ? "bg-blue-50 border-r-4 border-blue-500"
                                : ""
                            }`}
                          >
                            <div className="flex items-center">
                              <div
                                className={`w-4 h-4 border-2 mr-3 flex items-center justify-center ${
                                  currentSlot.dayOfWeek.includes(day)
                                    ? "bg-blue-500 border-blue-500"
                                    : "border-gray-300"
                                }`}
                              >
                                {currentSlot.dayOfWeek.includes(day) && (
                                  <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                  </svg>
                                )}
                              </div>
                              <span className={currentSlot.dayOfWeek.includes(day) ? "text-blue-700 font-medium" : "text-gray-700"}>
                                {day}
                              </span>
                            </div>
                            {currentSlot.dayOfWeek.includes(day) && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setCurrentSlot((prev) => ({
                                    ...prev,
                                    dayOfWeek: prev.dayOfWeek.filter((d) => d !== day),
                                  }));
                                }}
                                className="w-5 h-5 bg-red-100 rounded-full hover:bg-red-200 text-red-600 flex items-center justify-center"
                              >
                                ×
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    Start Time <span className="text-red-500">*</span>
                  </label>
                  <TimePicker
                    value={
                      currentSlot.startTime
                        ? dayjs(currentSlot.startTime, "HH:mm")
                        : null
                    }
                    onChange={(time, timeString) =>
                      setCurrentSlot((prev) => ({
                        ...prev,
                        startTime: timeString,
                      }))
                    }
                    format="HH:mm"
                    className="w-full"
                    minuteStep={5}
                    use12Hours={false}
                    placeholder="Select time"
                    needConfirm={false}
                    showNow={false}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-[#004276] mb-1 font-medium">
                    End Time <span className="text-red-500">*</span>
                  </label>
                  <TimePicker
                    value={
                      currentSlot.endTime
                        ? dayjs(currentSlot.endTime, "HH:mm")
                        : null
                    }
                    onChange={(time, timeString) =>
                      setCurrentSlot((prev) => ({
                        ...prev,
                        endTime: timeString,
                      }))
                    }
                    format="HH:mm"
                    className="w-full"
                    minuteStep={5}
                    use12Hours={false}
                    placeholder="Select time"
                    needConfirm={false}
                    showNow={false}
                  />
                </div>
                <div className="flex flex-col justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      if (
                        currentSlot.dayOfWeek.length > 0 &&
                        currentSlot.startTime &&
                        currentSlot.endTime
                      ) {
                        const newSlots = currentSlot.dayOfWeek.map(day => {
                          const newSlot = {
                            dayOfWeek: day, 
                            startTime: currentSlot.startTime,
                            endTime: currentSlot.endTime,
                          };

                          if (currentSlot.weekNumbers.length > 0) {
                            newSlot.weekNumbers = currentSlot.weekNumbers;
                          }

                          return newSlot;
                        });

                        setFormData((prev) => ({
                          ...prev,
                          timeSlots: [...prev.timeSlots, ...newSlots],
                        }));

                        setFieldErrors(prev => ({ ...prev, timeSlots: null }));

                        setCurrentSlot({
                          dayOfWeek: [], 
                          startTime: "",
                          endTime: "",
                          weekNumbers: [],
                        });
                      } else {
                        toast.error(
                          "Please fill all time-slot fields (Week is optional)"
                        );
                      }
                    }}
                    className="w-full bg-[#004276] hover:bg-[#003a5c] text-white py-2 rounded-lg transition"
                  >
                    Add
                  </button>
                </div>
              </div>

              {/* Time Slot Summary */}
              {formData.timeSlots.length > 0 && (
                  <div className="mt-4 space-y-2">
                    {formData.timeSlots.map((slot, index) => (
                      <div
                        key={index}
                        className="flex justify-between items-center bg-gray-100 px-4 py-2 rounded-lg"
                      >
                        <div className="text-sm text-gray-700">
                          {slot.dayOfWeek} – {slot.startTime} to {slot.endTime}
                          {slot.weekNumbers?.length > 0 && (
                            <span className="ml-2 text-xs text-gray-500">
                              (Weeks: {slot.weekNumbers.join(", ")})
                            </span>
                          )}
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            const updated = formData.timeSlots.filter(
                              (_, i) => i !== index
                            );
                            setFormData((prev) => ({
                              ...prev,
                              timeSlots: updated,
                            }));
                            // Add error if no time slots left
                            if (updated.length === 0) {
                              setFieldErrors(prev => ({ ...prev, timeSlots: "At least one time slot is required" }));
                            }
                          }}
                          className="text-red-500 hover:text-red-700 font-bold transition"
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
              )}
              
              {/* Error message for time slots */}
              {fieldErrors.timeSlots && (
                <p className="text-red-500 text-xs mt-2">{fieldErrors.timeSlots}</p>
              )}

<h3 className="mt-4 text-lg font-semibold text-[#004276]">
                Slot Duration
              </h3>
              <InputField
                label="Duration (minutes)"
                name="slotDuration"
                value={formData.slotDuration}
                onChange={handleChange}
                error={fieldErrors.slotDuration}
                type="number"
                min="1"
                placeholder="Enter duration in minutes"
              />
            </div>

            {/* ────────────────────────────────────────────────────────────────────── */}
            {/* SLOT DURATION */}
            {/* ────────────────────────────────────────────────────────────────────── */}
            {/* <div className="rounded-lg border border-gray-200 p-6 shadow-sm">
              <h3 className="mb-4 text-lg font-semibold text-[#004276]">
                Slot Duration
              </h3>
              <InputField
                label="Duration (minutes)"
                name="slotDuration"
                value={formData.slotDuration}
                onChange={handleChange}
                error={fieldErrors.slotDuration}
                type="number"
                min="1"
                placeholder="Enter duration in minutes"
              />
            </div> */}

            {/* ────────────────────────────────────────────────────────────────────── */}
            {/* ABOUT DOCTOR */}
            {/* ────────────────────────────────────────────────────────────────────── */}
            <div className="rounded-lg border border-gray-200 p-6 shadow-sm">
              <h3 className="mb-4 text-lg font-semibold text-[#004276]">
                About Doctor
              </h3>
              <InputField
                label="Doctor Bio"
                name="bio"
                value={formData.bio}
                onChange={handleChange}
                type="textarea"
                rows={4}
                error={fieldErrors.bio}
              />
            </div>
          </div>

          {/* ────────────────────────────────────────────────────────────────────── */}
          {/* SUBMIT BUTTON */}
          {/* ────────────────────────────────────────────────────────────────────── */}
          <div className="flex justify-center mt-10">
            <button
              onClick={handleNext}
              // disabled={!isFormValid() || isLoggingIn}
              disabled={isLoggingIn}
              className="w-full max-w-md rounded-full bg-gradient-to-r from-[#004172] to-[#3cba84] px-10 py-3 font-medium text-white disabled:opacity-50 transition-opacity md:w-[335px] md:max-w-none"
            >
              {isLoggingIn ? "Updating..." : "Update Doctor"}
            </button>
          </div>
        </div>
      </DashboardLayout>

      {/* Photo Modal */}
      {photoModal.isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={closePhotoModal}>
          <div className="relative w-[70vw] h-[80vh] overflow-hidden" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button
              onClick={closePhotoModal}
              className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-opacity-70 transition-colors"
            >
              ×
            </button>

            {/* Photo Display */}
            {photoModal.photoUrl && (
              <div className="bg-white rounded-lg overflow-hidden w-full h-full">
                {photoModal.photoUrl && (photoModal.photoUrl.includes('data:image') || photoModal.photoUrl.includes('.jpg') || photoModal.photoUrl.includes('.png') || photoModal.photoUrl.includes('.jpeg')) ? (
                  <img
                    src={photoModal.photoUrl}
                    alt="Photo preview"
                    className="w-full h-full object-contain"
                  />
                ) : (
                  <div className="w-full h-full">
                    <iframe
                      src={photoModal.photoUrl}
                      className="w-full h-full border-0"
                      title="PDF Document"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

function InputField({
  label,
  name,
  value,
  onChange,
  type = "text",
  rows = 1,
  showRequired = true,
  error,
  ...rest
}) {
  const isTextarea = type === "textarea";
  const isReadOnly = rest.readOnly;
  const fieldClassName = `w-full rounded-lg border px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
    error ? "border-red-500" : "border-gray-200"
  } ${isReadOnly ? "bg-gray-50 cursor-not-allowed" : ""}`;

  return (
    <div className="flex flex-col">
      <label className="text-sm text-[#004276] mb-1 font-medium">
        {label} {showRequired && <span className="text-red-500">*</span>}
      </label>
      {isTextarea ? (
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          rows={rows}
          placeholder="Enter here"
          required={showRequired}
          className={`${fieldClassName} resize-none`}
          {...rest}
        />
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder="Enter here"
          required={showRequired}
          className={fieldClassName}
          {...rest}
        />
      )}
      {error && (
        <p className="text-red-500 text-xs mt-1">{error}</p>
      )}
    </div>
  );
}

function FileInputField({ label, name, file, onChange, error }) {
  const [previewURL, setPreviewURL] = useState(null);

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file);
      setPreviewURL(url);
      return () => {
        URL.revokeObjectURL(url);
        setPreviewURL(null);
      };
    } else {
      setPreviewURL(null);
    }
  }, [file]);

  const isImage = file && file.type && file.type.startsWith("image/");

  return (
    <div className="flex flex-col">
      <label className="text-sm text-[#004276] mb-1 font-medium">
        {label} <span className="text-red-500">*</span>
      </label>
      <input
        type="file"
        name={name}
        accept="image/*,application/pdf"
        onChange={onChange}
        required
        className={`w-full rounded-lg border px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
          error ? 'border-red-500' : 'border-gray-200'
        }`}
      />

      {file && (
        <p className="text-xs text-gray-600 mt-1">Selected: {file.name}</p>
      )}

      {isImage && previewURL && (
        <img
          src={previewURL}
          alt="Preview"
          className="mt-2 max-w-[200px] max-h-[150px] object-contain border border-gray-200 rounded-md shadow-sm"
        />
      )}

      {/* Only render PDF link if file exists AND is a PDF */}
      {file && !isImage && previewURL && file.type === "application/pdf" && (
        <p className="mt-2">
          <a
            href={previewURL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#004276] underline text-sm hover:text-[#003a5c] transition"
          >
            View PDF
          </a>
        </p>
      )}
      
      {error && (
        <p className="text-red-500 text-xs mt-1">{error}</p>
      )}
    </div>
  );
}

function DatePickerField({ label, name, value, onChange, error }) {
  return (
    <div className="flex flex-col">
      <label className="text-sm text-[#004276] mb-1 font-medium">
        {label} <span className="text-red-500">*</span>
      </label>
      <DatePicker
        value={value ? dayjs(value) : null}
        onChange={(date) => {
          onChange({
            target: {
              name,
              value: date ? date.format("YYYY-MM-DD") : "",
            },
          });
        }}
        format="DD-MM-YYYY"
        placeholder="DD-MM-YYYY"
        className={`w-full border border-gray-200 rounded-lg px-3 py-2 ${
          error ? 'border-red-500' : 'border-gray-200'
        }`}
        showToday
        allowClear
      />
      {error && (
        <p className="text-red-500 text-xs mt-1">{error}</p>
      )}
    </div>
  );
}

function SelectField({ label, name, value, onChange, options }) {
  return (
    <div className="flex flex-col">
      <label className="text-sm text-[#004276] mb-1 font-medium">
        {label} <span className="text-red-500">*</span>
      </label>
      <select
        name={name}
        value={value}
        onChange={onChange}
        className="w-full rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition"
      >
        <option value="">Select</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
}

export default DoctorEdit;